import { IBaseEntity } from './../system/BaseEntity';

export enum Interval {
  OneTime,
  Daily,
  Weekly,
  Monthly,
  DelayDays,
}

export enum TriggerType {
  Schedule,
  Evergreen,
  Infographics,
  News,
  Properties,
  Reviews,
  BlogPosts,
  OneOff,
}

export const TriggerTypeNames: { [key in TriggerType]: string } = {
  [TriggerType.Schedule]: "Schedule",
  [TriggerType.Evergreen]: "Evergreen",
  [TriggerType.Infographics]: "Infographics",
  [TriggerType.News]: "News",
  [TriggerType.Properties]: "Properties",
  [TriggerType.Reviews]: "Reviews",
  [TriggerType.BlogPosts]: "Blog Posts",
  [TriggerType.OneOff]: "One Off",
};

export enum PropertyMedia {
  None,
  OgVideo,
  OgImage,
  PropertyImages,
}

export interface ISocialTrigger extends IBaseEntity {
  triggerType: TriggerType;

  // Relevant for Properties and maybe Reviews
  branches?: string;

  // Properties
  minPriceSales?: number;
  minPriceLettings?: number;
  postOnReduced?: boolean;
  postOnCompleted?: boolean; // Sold or let
  postOnNew?: boolean; // New property on market
  isSales?: boolean;
  isLettings?: boolean;
  propertyMedia?: PropertyMedia;
  numberOfImages?: number;

  // Review
  minStars?: number;

  // News
  allowContentEngine?: boolean;
  allowNonContentEngine?: boolean;

  // Schedule
  startDateTime?: string; // ISO date string or null
  endDateTime?: string;   // ISO date string or null

  // TimeOfDay originally derived from StartDateTime.TimeOfDay (TimeSpan?)
  // Represent as a time string (e.g. "HH:mm:ss") or null
  timeOfDay?: string;

  interval?: Interval;
  weekDays?: string; // e.g. "Monday,Friday"
  monthDays?: string; // e.g. "1,15,28"
  delayIntervalDays?: number;
}